














































import { Component, Vue, Prop } from "vue-property-decorator";
import { AppContainer, TYPES } from "@/app/index";
import { ItemsService } from "@/services";
import { Items, ItemsGroupedByItemDescription, DataSet, Query, Condition, ConditionOperator, Sort, SortDirections, ConditionDataType, Filter, LogicalOperator } from "@/models";
import { EntityListHelper } from '@/helpers';

@Component
export default class ItemInformation extends Vue {
  @Prop()
  private item!: ItemsGroupedByItemDescription;

  @Prop()
  private BrandingType!: number;

  private EntityList = new EntityListHelper<ItemsService, Items>(
    this,
    AppContainer.get<ItemsService>(TYPES.Services.ItemsService),
    new DataSet(
      [],
      new Query(new Filter(
        LogicalOperator.And,
        [],
        [
          new Condition("SuperCallNumber", ConditionOperator.EqualTo, this.item.SuperCallNumber, ConditionDataType.String),
          new Condition("ItemDescription", ConditionOperator.EqualTo, this.item.ItemDescription, ConditionDataType.String)
        ])),
      [new Sort("ItemDescription", SortDirections.Ascending)]),
    [
      { key: "ItemDescription", label: "Item Description", thStyle: { minWidth: '400px' } },
      { key: "Asset_Number", label: "Asset Number", sortable: true, thStyle: { 'text-wrap': 'wrap' } },
      { key: "User_Ref1", label: "User Reference", sortable: true, thStyle: { 'text-wrap': 'wrap' } },
      { key: "Serial_Number", label: "Serial Number", sortable: true, thStyle: { 'text-wrap': 'wrap' } },
      { key: "InspectionType", label: "Inspection Type", sortable: true, thStyle: { 'text-wrap': 'wrap' } },
      { key: "ServiceEngineer", label: "Service Engineer Required", sortable: true, thStyle: { 'text-wrap': 'wrap' } },
      { key: "SupplementaryTestingReq", label: "Supplementary Test Required", sortable: true, thStyle: { 'text-wrap': 'wrap' } }
    ],
    () => { return new Items(); }
  );

  public created(): void {
    this.EntityList.DataSet.Configure((dataSet) => {
      this.EntityList.Service.ODataQuery<Items>(`?${dataSet.ToDataQuery()}`)
        .then((response) => {
          dataSet.DataLoadedCallback(response.value.map(entity => new Items(entity)), response.count);
        }).catch((error) => {
          toastr.error(error.response.data);
        });
    });
    this.EntityList.DataSet.Load();
  }
}
